import {
  fetchOffersSuccess,
  fetchAccoladesSuccess,
  fetchAthleteProfileFail,
  fetchProfilePhotoRequest,
  fetchProfilePhotoSuccess,
  fetchProfilePhotoFail,
  removeAccolade,
  removeOffer,
  setLoading,
  setProfile,
  setPositionDrill,
  setAthletes,
  setFavouriteAthletes,
  setSimilarAthletes,
} from "./slices/athleteSlice";
import {
  getOffers,
  getAccolades,
  deleteAccolade,
  deleteOffer,
  getOffersAccolades,
  getAthleteProfile,
  getPositionDrillsResults,
  SearchAthleteByParams,
  SearchFavouriteAthleteByParams,
  SearchAthleteByAthleteId,
} from "../services/AthleteService";
import { retrieveProfilePhotos } from "../services/FileUploadService";

export const fetchOffers = (apiInstance, userId) => async (dispatch) => {
  try {
    const data = await getOffers(apiInstance, userId);
    dispatch(fetchOffersSuccess(data));
  } catch (error) {
    dispatch(
      fetchAthleteProfileFail(error.message || "Failed to fetch offers"),
    );
  }
};

export const fetchAccolades = (apiInstance, userId) => async (dispatch) => {
  try {
    const data = await getAccolades(apiInstance, userId);
    dispatch(fetchAccoladesSuccess(data));
  } catch (error) {
    dispatch(
      fetchAthleteProfileFail(error.message || "Failed to fetch accolades"),
    );
  }
};

export const fetchProfilePhoto = (apiInstance, userId) => async (dispatch) => {
  dispatch(fetchProfilePhotoRequest());
  try {
    const data = await retrieveProfilePhotos(apiInstance);
    dispatch(fetchProfilePhotoSuccess(data));
  } catch (error) {
    dispatch(
      fetchProfilePhotoFail(error.message || "Failed to fetch profile photo"),
    );
  }
};

export const deleteAccoladeAction =
  (apiInstance, accoladeId) => async (dispatch) => {
    try {
      await deleteAccolade(apiInstance, accoladeId);
      dispatch(removeAccolade(accoladeId));
    } catch (err) {
      throw new Error(`deleteAccoladeAction failed: ${err.message}`);
    }
  };

export const deleteOfferAction = (apiInstance, offerId) => async (dispatch) => {
  try {
    await deleteOffer(apiInstance, offerId);
    dispatch(removeOffer(offerId));
  } catch (err) {
    throw new Error(`deleteOfferAction failed: ${err.message}`);
  }
};

export const getOffersAccoladesAction =
  (apiInstance, userId) => async (dispatch) => {
    try {
      const response = await getOffersAccolades(apiInstance, userId);
      dispatch(fetchAccoladesSuccess(response.accoladesList));
      dispatch(fetchOffersSuccess(response.offersList));
    } catch (err) {
      throw new Error(`getOffersAccoladesAction failed: ${err.message}`);
    }
  };

export const setProfileAction = (apiInstance, userId) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await getAthleteProfile(apiInstance, userId);
    dispatch(setProfile(response));
  } catch (err) {
    throw new Error(`getAthleteProfile failed: ${err.message}`);
  } finally {
    dispatch(setLoading(false));
  }
};
export const setProfileActionSync =
  (apiInstance, userId) => async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await getAthleteProfile(apiInstance, userId);
      return response;
    } catch (err) {
      throw new Error(`getAthleteProfile failed: ${err.message}`);
    } finally {
      dispatch(setLoading(false));
    }
  };

export const getAthletePositionDrillsAction =
  (apiInstance, userId) => async (dispatch) => {
    try {
      setLoading(true);
      const response = await getPositionDrillsResults(apiInstance, userId);
      dispatch(setPositionDrill(response.data));
    } catch (err) {
      throw new Error(`getPositionDrillsResults failed: ${err.message}`);
    } finally {
      dispatch(setLoading(false));
    }
  };

export const searchAthleteAction =
  (apiInstance, q, setLoading) => async (dispatch) => {
    try {
      const response = await SearchAthleteByParams(apiInstance, q);
      dispatch(setAthletes(response));
    } catch (error) {
      throw new Error(`searchAthleteAction failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

export const searchFavouriteAthleteAction =
  (apiInstance, q, setLoading) => async (dispatch) => {
    try {
      const response = await SearchFavouriteAthleteByParams(apiInstance, q);
      dispatch(setFavouriteAthletes(response));
    } catch (error) {
      throw new Error(`searchFavouriteAthleteAction failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

export const searchSimilarAthleteAction =
  (apiInstance, queryString, setLoading) => async (dispatch) => {
    try {
      const response = await SearchAthleteByAthleteId(apiInstance, queryString);
      dispatch(setSimilarAthletes(response));
    } catch (error) {
      console.error("SearchAthleteByAthleteIdAction failed:", error);
      dispatch(setSimilarAthletes([]));
    } finally {
      setLoading(false);
    }
  };
